import React from 'react';

// Slide 1: Welcome
export const Slide1 = ({ t }) => (
    <div className="content-pane">
        <div className="accent-line"></div>
        <div className="label">{t('s1.label')}</div>
        <h1>{t('s1.title')}</h1>
        <p className="description">{t('s1.desc')}</p>
        <div style={{ fontWeight: 600, fontSize: '0.9rem', letterSpacing: '3px', color: 'var(--ph-accent)', marginTop: '2rem' }}>
            {t('s1.tag')}
        </div>
    </div>
);

export const Slide1Image = () => (
    <div className="image-pane">
        <img src="/images/ezerp-partners/MgbYDtu_O97WeUjq-e6n4.avif" alt="EzERP Hero" />
    </div>
);

// Slide 2: The Problem
export const Slide2 = ({ t }) => (
    <div className="content-pane">
        <div className="label">{t('s2.label')}</div>
        <h2>{t('s2.title')}</h2>
        
        <div className="grid-container">
            <div className="feature-bar" style={{'--i': 1}}>
                <div className="feature-icon" style={{background: '#3182CE'}}>🔁</div>
                <div className="feature-text">
                    <h3>{t('s2.c1h')}</h3>
                    <p>{t('s2.c1p')}</p>
                </div>
            </div>
            <div className="feature-bar" style={{'--i': 2}}>
                <div className="feature-icon" style={{background: '#D53F8C'}}>📉</div>
                <div className="feature-text">
                    <h3>{t('s2.c2h')}</h3>
                    <p>{t('s2.c2p')}</p>
                </div>
            </div>
            <div className="feature-bar" style={{'--i': 3}}>
                <div className="feature-icon" style={{background: '#4A5568'}}>🔧</div>
                <div className="feature-text">
                    <h3>{t('s2.c3h')}</h3>
                    <p>{t('s2.c3p')}</p>
                </div>
            </div>
            <div className="feature-bar" style={{'--i': 4}}>
                <div className="feature-icon" style={{background: '#DD6B20'}}>🧘</div>
                <div className="feature-text">
                    <h3>{t('s2.c4h')}</h3>
                    <p>{t('s2.c4p')}</p>
                </div>
            </div>
        </div>
    </div>
);

export const Slide2Image = () => (
    <div className="image-pane">
        <img src="/images/ezerp-partners/W7KeclG-uyeY2gl7HWNKv.avif" alt="Broken Fragments" />
    </div>
);

// Slide 3: The Solution
export const Slide3 = ({ t }) => (
    <div className="content-pane">
        <h2>{t('s3.title')}</h2>
        <p className="description">{t('s3.desc')}</p>
        
        <div className="feature-grid">
            <div className="feature-card">
                <div className="card-image-box">
                    <img src="/images/ezerp-partners/ZCui3vmObBGpHiepFSeXu.avif" alt="Financial Management" />
                </div>
                <h3>{t('s3.c1h')}</h3>
                <p>{t('s3.c1p')}</p>
            </div>
            <div className="feature-card">
                <div className="card-image-box">
                    <img src="/images/ezerp-partners/I3Vq5Hxd-GR2RpZfFyMII.avif" alt="Logistics & Delivery" />
                </div>
                <h3>{t('s3.c2h')}</h3>
                <p>{t('s3.c2p')}</p>
            </div>
            <div className="feature-card">
                <div className="card-image-box">
                    <img src="/images/ezerp-partners/MgbYDtu_O97WeUjq-e6n4.avif" alt="WMS / Warehouse" />
                </div>
                <h3>{t('s3.c3h')}</h3>
                <p>{t('s3.c3p')}</p>
            </div>
            <div className="feature-card">
                <div className="card-image-box">
                    <img src="/images/ezerp-partners/_VcpJt1spDVMIEPLuOcvO.avif" alt="CRM & Sales Pipeline" />
                </div>
                <h3>{t('s3.c4h')}</h3>
                <p>{t('s3.c4p')}</p>
            </div>
        </div>
    </div>
);

// Slide 4: Operational Intelligence
export const Slide4 = ({ t }) => (
    <div className="content-pane" style={{maxWidth: '1400px'}}>
        <h2>{t('s4.title')}</h2>
        
        <div className="dashboard-layout">
            <img src="/images/ezerp-partners/RKnwsucU2MBxF8h3ep-71.avif" alt="EzERP Dashboard" className="dashboard-image-main" />
            
            <div className="side-text">
                <h3>{t('s4.subh')}</h3>
                <p>{t('s4.subp')}</p>
            </div>
        </div>

        <div className="arrow-grid">
            <div className="arrow-item">
                <div className="arrow-icon"></div>
                <p>{t('s4.a1')}</p>
            </div>
            <div className="arrow-item">
                <div className="arrow-icon"></div>
                <p>{t('s4.a2')}</p>
            </div>
            <div className="arrow-item">
                <div className="arrow-icon"></div>
                <p>{t('s4.a3')}</p>
            </div>
            <div className="arrow-item">
                <div className="arrow-icon"></div>
                <p>{t('s4.a4')}</p>
            </div>
        </div>
    </div>
);

// Slide 5: Modules
export const Slide5 = ({ t }) => (
    <div className="s5-wrapper">
        <h2 className="s5-title">{t('s5.title')}</h2>
        <p className="s5-subtitle">{t('s5.subtitle')}</p>

        <div className="s5-row">
            <div className="s5-card">
                <div className="s5-card-top">
                    <div className="s5-badge">1</div>
                </div>
                <div className="s5-card-body">
                    <h3 className="s5-card-title">{t('s5.m1')}</h3>
                    <p className="s5-card-desc">{t('s5.m1p')}</p>
                </div>
            </div>
            <div className="s5-card">
                <div className="s5-card-top">
                    <div className="s5-badge">2</div>
                </div>
                <div className="s5-card-body">
                    <h3 className="s5-card-title">{t('s5.m2')}</h3>
                    <p className="s5-card-desc">{t('s5.m2p')}</p>
                </div>
            </div>
            <div className="s5-card">
                <div className="s5-card-top">
                    <div className="s5-badge">3</div>
                </div>
                <div className="s5-card-body">
                    <h3 className="s5-card-title">{t('s5.m3')}</h3>
                    <p className="s5-card-desc">{t('s5.m3p')}</p>
                </div>
            </div>
        </div>

        <div className="s5-row s5-row-2">
            <div className="s5-card">
                <div className="s5-card-top">
                    <div className="s5-badge">4</div>
                </div>
                <div className="s5-card-body">
                    <h3 className="s5-card-title">{t('s5.m4')}</h3>
                    <p className="s5-card-desc">{t('s5.m4p')}</p>
                </div>
            </div>
            <div className="s5-card">
                <div className="s5-card-top">
                    <div className="s5-badge">5</div>
                </div>
                <div className="s5-card-body">
                    <h3 className="s5-card-title">{t('s5.m5')}</h3>
                    <p className="s5-card-desc">{t('s5.m5p')}</p>
                </div>
            </div>
        </div>
    </div>
);

// Slide 6: Logistics & WMS
export const Slide6 = ({ t }) => (
    <div className="logistics-card slide-6-card" style={{display: 'flex', width: '100%', height: '100vh', overflow: 'hidden', background: '#212326', padding: 0}}>
        <div className="logistics-content" style={{flex: '0 0 52%', padding: '6rem 5rem', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
            <h2 className="slide-title left-aligned" style={{textAlign: 'left', marginBottom: '3.5rem', fontSize: '3.2rem'}}>
                <span>{t('s6.title_pre')}</span><br/><span>{t('s6.title_post')}</span>
            </h2>
            
            <div className="logistics-grid">
                <div className="logistics-col log-col">
                    <h3 className="module-header">{t('s6.col1h')}</h3>
                    <ul className="bullets log-bullets">
                        <li>{t('s6.l1')}</li>
                        <li>{t('s6.l2')}</li>
                        <li>{t('s6.l3')}</li>
                        <li>{t('s6.l4')}</li>
                    </ul>
                </div>
                
                <div className="logistics-col log-col">
                    <h3 className="module-header">{t('s6.col2h')}</h3>
                    <ul className="bullets log-bullets">
                        <li>{t('s6.w1')}</li>
                        <li>{t('s6.w2')}</li>
                        <li>{t('s6.w3')}</li>
                        <li>{t('s6.w4')}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div className="logistics-image-wrapper logistics-image-side" style={{flex: 1, height: '100%', background: '#F1ECEA', position: 'relative', margin: 0, width: '100%'}}>
            <img src="/images/ezerp-partners/trucks.png" alt="Logistics Map" className="logistics-image accent-map" style={{width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'left center', display: 'block'}} />
        </div>
    </div>
);

// Slide 7: The Land-and-Expand Sales Motion
export const Slide7 = ({ t }) => (
    <div className="s7-wrapper">
        <h1 className="s7-title">{t('s7.title')}</h1>
        <p className="s7-subtitle">{t('s7.subtitle')}</p>

        <div className="s7-flow">
            <div className="s7-step">
                <div className="s7-circle">
                    <svg className="s7-icon" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="32" cy="32" r="26"></circle>
                        <circle cx="32" cy="32" r="16"></circle>
                        <circle cx="32" cy="32" r="6"></circle>
                        <polyline points="40,22 44,18"></polyline>
                        <polyline points="24,22 20,18"></polyline>
                        <polyline points="40,42 44,46"></polyline>
                        <polyline points="24,42 20,46"></polyline>
                        <polyline points="26,34 30,38 42,26" strokeWidth="2.5"></polyline>
                    </svg>
                </div>
                <span className="s7-label">{t('s7.step1')}</span>
            </div>
            <svg className="s7-arrow" viewBox="0 0 32 64" fill="none" preserveAspectRatio="none"><polyline points="4,4 28,32 4,60" stroke="#7a3e24" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></polyline></svg>
            <div className="s7-step">
                <div className="s7-circle">
                    <svg className="s7-icon" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="8,44 22,28 32,36 52,14"></polyline>
                        <polyline points="40,14 52,14 52,26"></polyline>
                        <line x1="8" y1="50" x2="56" y2="50"></line>
                        <path d="M36 44 L34 54 L42 54 L40 44 Z"></path>
                        <line x1="33" y1="48" x2="41" y2="48"></line>
                    </svg>
                </div>
                <span className="s7-label">{t('s7.step2')}</span>
            </div>
            <svg className="s7-arrow" viewBox="0 0 32 64" fill="none" preserveAspectRatio="none"><polyline points="4,4 28,32 4,60" stroke="#7a3e24" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></polyline></svg>
            <div className="s7-step">
                <div className="s7-circle">
                    <svg className="s7-icon" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="32,8 8,20 32,32 56,20 32,8"></polygon>
                        <polyline points="8,32 32,44 56,32"></polyline>
                        <polyline points="8,44 32,56 56,44"></polyline>
                    </svg>
                </div>
                <span className="s7-label">{t('s7.step3')}</span>
            </div>
            <svg className="s7-arrow" viewBox="0 0 32 64" fill="none" preserveAspectRatio="none"><polyline points="4,4 28,32 4,60" stroke="#7a3e24" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></polyline></svg>
            <div className="s7-step">
                <div className="s7-circle">
                    <svg className="s7-icon" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="10" y="28" width="44" height="28" rx="1"></rect>
                        <polyline points="6,28 32,10 58,28"></polyline>
                        <rect x="20" y="38" width="10" height="18"></rect>
                        <rect x="34" y="38" width="10" height="18"></rect>
                        <line x1="10" y1="28" x2="54" y2="28"></line>
                    </svg>
                </div>
                <span className="s7-label">{t('s7.step4')}</span>
            </div>
        </div>

        <p className="s7-synthesis" dangerouslySetInnerHTML={{__html: t('s7.synthesis')}}></p>
    </div>
);

// Slide 8: Why EzERP Wins Against Legacy ERP
export const Slide8 = ({ t }) => (
    <div className="content-pane" style={{ paddingTop: '5%', justifyContent: 'flex-start', alignItems: 'center' }}>
        <div className="s8-wrapper">
            <h1 className="s8-title">{t('s8.title')}</h1>

            <div className="s8-table">
                <div className="s8-col s8-col-legacy comp-col legacy">
                    <h3 className="s8-col-header comp-header">{t('s8.col1h')}</h3>
                    <ul className="s8-bullets comp-list">
                        <li>{t('s8.l1')}</li>
                        <li>{t('s8.l2')}</li>
                        <li>{t('s8.l3')}</li>
                        <li>{t('s8.l4')}</li>
                        <li>{t('s8.l5')}</li>
                    </ul>
                </div>
                <div className="s8-col s8-col-ezerp comp-col">
                    <h3 className="s8-col-header comp-header">{t('s8.col2h')}</h3>
                    <ul className="s8-bullets comp-list">
                        <li>{t('s8.e1')}</li>
                        <li>{t('s8.e2')}</li>
                        <li>{t('s8.e3')}</li>
                        <li>{t('s8.e4')}</li>
                        <li>{t('s8.e5')}</li>
                    </ul>
                </div>
            </div>

            <div className="s8-banner callout-box" style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                <svg className="s8-banner-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{width: '2rem', height: '2rem', color: 'var(--ph-accent)', flexShrink: 0}}>
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="9" y1="9" x2="15" y2="9"></line>
                    <line x1="9" y1="13" x2="15" y2="13"></line>
                    <line x1="9" y1="17" x2="13" y2="17"></line>
                </svg>
                <p className="s8-banner-text callout-text" style={{textAlign: 'left'}} dangerouslySetInnerHTML={{__html: t('s8.banner')}}></p>
            </div>
        </div>
    </div>
);

// Slide 9: Real Platform. Real Clients. Real Revenue.
export const Slide9 = ({ t }) => (
    <div className="s9-content-pane content-pane">
        <h1 className="s9-title">{t('s9.title')}</h1>

        <div className="s9-stats" style={{display: 'flex', gap: '3rem', marginBottom: '3rem'}}>
            <div className="s9-stat" style={{flex: 1}}>
                <div className="s9-stat-value" style={{fontSize: '3.5rem', fontFamily: 'Prata, serif', color: 'var(--ph-accent)'}}>{t('s9.v1')}</div>
                <div className="s9-stat-label" style={{fontSize: '1.2rem', fontWeight: 600, color: 'white', marginBottom: '0.5rem'}}>{t('s9.l1')}</div>
                <p className="s9-stat-desc" style={{opacity: 0.7}}>{t('s9.d1')}</p>
            </div>
            <div className="s9-stat" style={{flex: 1}}>
                <div className="s9-stat-icon" style={{height: '3.5rem', display: 'flex', alignItems: 'center', color: 'var(--ph-accent)'}}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{height: '2.5rem'}}>
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </div>
                <div className="s9-stat-label" style={{fontSize: '1.2rem', fontWeight: 600, color: 'white', marginBottom: '0.5rem'}}>{t('s9.l2')}</div>
                <p className="s9-stat-desc" style={{opacity: 0.7}}>{t('s9.d2')}</p>
            </div>
            <div className="s9-stat" style={{flex: 1}}>
                <div className="s9-stat-value s9-infinity" style={{fontSize: '3.5rem', fontFamily: 'Prata, serif', color: 'var(--ph-accent)'}}>∞</div>
                <div className="s9-stat-label" style={{fontSize: '1.2rem', fontWeight: 600, color: 'white', marginBottom: '0.5rem'}}>{t('s9.l3')}</div>
                <p className="s9-stat-desc" style={{opacity: 0.7}}>{t('s9.d3')}</p>
            </div>
        </div>

        <p className="s9-footer" style={{fontSize: '1.2rem', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '2rem'}} dangerouslySetInnerHTML={{__html: t('s9.footer')}}></p>
    </div>
);

export const Slide9Image = () => (
    <div className="image-pane">
        <img src="/images/ezerp-partners/kV1KLj76TNstriF-m9kNg.avif" alt="Real Platform Proof" />
    </div>
);

// Slide 10: Your Earnings as an EzERP Partner
export const Slide10 = ({ t }) => (
    <div className="content-pane" style={{ paddingTop: '5%', justifyContent: 'flex-start', alignItems: 'center' }}>
        <div className="s10-wrapper" style={{maxWidth: '1200px', margin: '0 auto', textAlign: 'center'}}>
            <h1 className="s10-title">{t('s10.title')}</h1>
            <p className="s10-subtitle description" style={{ margin: '0 auto' }}>{t('s10.subtitle')}</p>

            <div className="s10-table s8-table" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', margin: '3rem 0', textAlign: 'left'}}>
                <div className="s10-col s10-col-how comp-col">
                    <h3 className="s10-col-header comp-header" style={{color: 'white', borderColor: 'rgba(255,255,255,0.2)'}}>{t('s10.col1h')}</h3>
                    <ul className="s10-bullets comp-list">
                        <li>{t('s10.h1')}</li>
                        <li>{t('s10.h2')}</li>
                        <li>{t('s10.h3')}</li>
                        <li>{t('s10.h4')}</li>
                    </ul>
                </div>
                <div className="s10-col s10-col-why comp-col">
                    <h3 className="s10-col-header comp-header" style={{color: 'white', borderColor: 'rgba(255,255,255,0.2)'}}>{t('s10.col2h')}</h3>
                    <ul className="s10-bullets comp-list">
                        <li>{t('s10.w1')}</li>
                        <li>{t('s10.w2')}</li>
                        <li>{t('s10.w3')}</li>
                        <li>{t('s10.w4')}</li>
                    </ul>
                    <p className="s10-footnote" style={{marginTop: '2rem', fontStyle: 'italic', opacity: 0.6}}>{t('s10.footnote')}</p>
                </div>
            </div>

            <div className="s10-banner callout-box" style={{display: 'flex', alignItems: 'center', gap: '1rem', background: 'rgba(212, 182, 156, 0.1)'}}>
                <svg className="s10-banner-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{width: '2rem', height: '2rem', color: 'var(--ph-accent)', flexShrink: 0}}>
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="9" y1="9" x2="15" y2="9"></line>
                    <line x1="9" y1="13" x2="15" y2="13"></line>
                    <line x1="9" y1="17" x2="13" y2="17"></line>
                </svg>
                <p className="s10-banner-text callout-text" style={{textAlign: 'left'}} dangerouslySetInnerHTML={{__html: t('s10.banner')}}></p>
            </div>
        </div>
    </div>
);

// Slide 11: Call to Action
export const Slide11 = ({ t }) => (
    <div className="content-pane">
        <div className="accent-line"></div>
        <div className="label">{t('s11.label')}</div>
        <h2>
            <span>{t('s11.title_pre')}</span><br/><span>{t('s11.title_post')}</span>
        </h2>
        <p className="description">{t('s11.desc')}</p>
        <button className="btn" style={{width: 'auto', borderRadius: '50px', padding: '0 2rem', fontWeight: 600, fontSize: '1rem', marginTop: '1rem', height: '3.5rem'}}>
            {t('s11.cta')}
        </button>
    </div>
);

export const Slide11Image = () => (
    <div className="image-pane">
        <img src="/images/ezerp-partners/kV1KLj76TNstriF-m9kNg.avif" alt="Call to Action" />
    </div>
);

